import React, { useEffect, useState, useRef, memo } from "react";
import { NodeResizer, useReactFlow } from "reactflow";
import { FaArrowRotateRight } from "react-icons/fa6";

const CircleNode = memo(function CircleNode({ data, selected, width: nodeWidth, height: nodeHeight, id, style, ...rest }) {
  // 우선순위: data.width/height > nodeWidth/nodeHeight (ReactFlow props) > rest.width/height > style > 기본값
  // 타원도 가능하도록 width와 height를 각각 사용
  const width = data?.width || nodeWidth || rest?.width || (style?.width ? parseInt(style.width.replace('px', '')) : null) || 150;
  const height = data?.height || nodeHeight || rest?.height || (style?.height ? parseInt(style.height.replace('px', '')) : null) || 150;
  
  const { 
    fill = "transparent", 
    stroke = "#000000", 
    strokeWidth = 5,
    fillOpacity = 1,
    strokeOpacity = 1,
    fillRgba,
    strokeRgba,
    rotation = 0
  } = data || {};

  const { setNodes } = useReactFlow();
  const [isRotating, setIsRotating] = useState(false);
  const rotationStartRef = useRef({ angle: 0, clientX: 0, clientY: 0 });

  const [isShiftPressed, setIsShiftPressed] = useState(false);
  const nodeRef = useRef(null);
  useEffect(() => {
    if (!selected) return;
    const onKey = (e) => { if (e.key === 'Shift') setIsShiftPressed(e.type === 'keydown'); };
    window.addEventListener('keydown', onKey);
    window.addEventListener('keyup', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('keyup', onKey);
      setIsShiftPressed(false);
    };
  }, [selected]);

  // RGBA 색상이 있으면 사용, 없으면 opacity로 변환
  const fillColor = fillRgba || (fill === 'transparent' ? 'transparent' : fillOpacity < 1 
    ? (() => {
        const r = parseInt(fill.slice(1, 3), 16);
        const g = parseInt(fill.slice(3, 5), 16);
        const b = parseInt(fill.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${fillOpacity})`;
      })()
    : fill);
  
  const strokeColor = strokeRgba || (strokeOpacity < 1
    ? (() => {
        const r = parseInt(stroke.slice(1, 3), 16);
        const g = parseInt(stroke.slice(3, 5), 16);
        const b = parseInt(stroke.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${strokeOpacity})`;
      })()
    : stroke);
  
  // props 변경 감지 로깅
  useEffect(() => {
  }, [id, nodeWidth, nodeHeight, width, height, data?.width, data?.height, rest?.width, rest?.height, style?.width, style?.height]);
  

  
  

  
  // 타원의 중심점과 반지름 (가로/세로 반지름)
  const centerX = width / 2;
  const centerY = height / 2;
  const rx = width / 2 - strokeWidth / 2;
  const ry = height / 2 - strokeWidth / 2;
  
  return (
    <>
      <div 
        ref={nodeRef}
        id={`node-${id}`}
        style={{ 
          width, 
          height, 
          position: 'relative',
          transform: `rotate(${rotation}deg)`,
          transformOrigin: 'center center',
          // willChange: 'transform',
          // backfaceVisibility: 'hidden'
        }}
      >
      
      <NodeResizer
        color="#000000"
        lineColor="#000000"
        lineStyle={{ stroke: "#000000", strokeWidth: 1 }}
        handleStyle={{
          backgroundColor: "#ffffff",
          border: "4px solid #000000",
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          boxSizing: "border-box",
        }}
        isVisible={selected}
        minWidth={50}
        minHeight={50}
        keepAspectRatio={isShiftPressed}
      />
      
      
      {/* 콘텐츠 */}
      <svg width={width} height={height} style={{ display: 'block' }}>
        <ellipse
          cx={centerX}
          cy={centerY}
          rx={rx}
          ry={ry}
          fill={fillColor}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>

  </>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.id === nextProps.id &&
    prevProps.selected === nextProps.selected &&
    prevProps.width === nextProps.width &&
    prevProps.height === nextProps.height &&
    prevProps.data?.width === nextProps.data?.width &&
    prevProps.data?.height === nextProps.data?.height &&
    prevProps.data?.fill === nextProps.data?.fill &&
    prevProps.data?.stroke === nextProps.data?.stroke &&
    prevProps.data?.strokeWidth === nextProps.data?.strokeWidth &&
    prevProps.data?.fillOpacity === nextProps.data?.fillOpacity &&
    prevProps.data?.strokeOpacity === nextProps.data?.strokeOpacity &&
    prevProps.data?.fillRgba === nextProps.data?.fillRgba &&
    prevProps.data?.strokeRgba === nextProps.data?.strokeRgba &&
    prevProps.data?.rotation === nextProps.data?.rotation &&
    prevProps.data?.selectedBy === nextProps.data?.selectedBy &&
    prevProps.data?.showUserLabel === nextProps.data?.showUserLabel
  );
});

export default CircleNode;

